<template>
  <div>
    <!-- {{ selectedOrderReturn.item }} -->
    <el-table
      :data="selectedOrderReturn.item"
      border
      style="width: 100%"
      class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
      header-row-class-name="thead-light table-th-colorpd"
    >
      <el-table-column label="Image" min-width="100px">
        <template v-slot="{ row }">
          <img
            :src="
              row.staticAttributeImageId &&
              row.staticAttributeImageId.productImage &&
              row.staticAttributeImageId.productImage.length > 0
                ? getImage(row.staticAttributeImageId.productImage[0])
                : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Admin/Icons/girl-with-vr.png'
            "
            width="100px"
            height="100px"
            alt="image"
            class="w60px"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="productName"
        label="Product Detail"
        min-width="160px"
      >
        <template v-slot="{ row }">
          <div>{{ row.productName }}</div>
          <div>{{ row.attribute }}: {{ row.attributeVal }}</div>
          <div>{{ row.variation }}: {{ row.variationVal }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="attributeVal" min-width="160px">
        <template slot-scope="scope" slot="header">
          <div>{{ scope.row.attribute }}</div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column
        prop="variationVal"
        :label="row.variation"
        min-width="160px"
        v-slot="{ row }"
      >
      </el-table-column> -->

      <el-table-column prop="discountedPrice" label="Price" min-width="160px">
      </el-table-column>
      <el-table-column prop="quantity" label="Quantity" min-width="160px">
      </el-table-column>
    </el-table>
    <!-- <div class="w-full flex justify-end mt-6">
      <el-pagination
        background
        layout="prev,pager,next"
        :total="100"
      ></el-pagination>
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    selectedOrderReturn: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tableData: [
        {
          productName: "abcd",
          price: "₹2542",
        },
      ],
    };
  },
  methods: {
    getImage(img) {
      // console.log(`${this.$imageURL}/${img}`);
      return `${this.$imageURL}/${img}`;
    },
  },
};
</script>
